module.exports = __webpack_public_path__ + "img/document-gray.b61b5507.svg";